import type { ReactNode } from 'react';

export const symbol_call_to_action: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Zm149-54h383q21.67 0 36.83-15.44Q724-304.88 724-326.94 724-349 708.83-364q-15.16-15-36.83-15H288q-21.67 0-36.83 15.24-15.17 15.23-15.17 37 0 21.76 15.46 37.26Q266.92-274 289-274Z"
		/>
	</svg>
);
